import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "./../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { LinkedDevice } from "@/api/devices";

interface IEditDeviceForm {
  id: string;
  name: string;
  location: number;
  floor: number;
}

const editDeviceFields: InputField[] = [
  {
    label: "ID Устройства",
    name: "id",
    placeholder: "a1b2c3d4e5f6789012345678901234ef",
    type: "text",
    isRequired: true,
  },
  {
    label: "Название",
    name: "name",
    placeholder: "Dispenser Floor 1",
    type: "text",
    isRequired: true,
  },
  {
    label: "Локация",
    name: "location",
    placeholder: "1",
    type: "location",
    isRequired: true,
  },
  {
    label: "Этаж",
    name: "floor",
    placeholder: "1",
    type: "text",
    isRequired: true,
  },
];

export function EditDeviceModal({
  disclosure,
  device,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  device: LinkedDevice | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErrors] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: IEditDeviceForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.devices
        .update(device?.id || 0, {
          name: data.name,
          location_id: data.location,
          floor: data.floor,
        })
        .then((_data) => {
          toast.success("Устройство успешно обновлено");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.devices
        .delete(device?.id || 0)
        .then((_data) => {
          toast.success("Устройство успешно отвязано");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErrors(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование устройства"
      modalErrors={modalErrors}
      fields={editDeviceFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitButtonText="Сохранить"
      deleteButtonText="Отвязать"
      defaultValues={{
        id: device?.device_id,
        name: device?.name,
        location: device?.location_id,
        floor: device?.floor,
      }}
    />
  );
}

